module.exports = __webpack_public_path__ + "img/history.4b2a1004.png";